export function createRegexValidator(pattern) {
    return value => {
        if (typeof value !== 'string') {
            return false;
        }
        return pattern.test(value);
    };
}
